module.exports = __webpack_public_path__ + "media/application/images/demsoc/hero/polychrome_3-4840a81e313de6152f332bfcefcc230f.jpg";